const baseState = {
    isGift: false,
    firstName: null,
    lastName: null,
    mobile: null,
    message: null,
}

export default function reducer(state = baseState, action) {
    switch (action.type) {
        case 'PLACE_ORDER_SUCCESS':
        case '2_PHASE_COMPLETE':
            return {
                ...state,
                isGift: false,
                message: null,
            }
        case 'SET_IS_GIFT':
            return {
                ...state,
                isGift: action.payload,
            }
        case 'SET_GIFT_FIRSTNAME':
            return {
                ...state,
                firstName: action.payload,
            }
        case 'SET_GIFT_LASTNAME':
            return {
                ...state,
                lastName: action.payload,
            }
        case 'SET_GIFT_MOBILE':
            return {
                ...state,
                mobile: action.payload,
            }
        case 'SET_GIFT_MESSAGE':
            return {
                ...state,
                message: action.payload,
            }
        case 'USER_LOGOUT':
            return { ...baseState }
        default:
            return state
    }
}
